// Shared category-option helpers that were duplicated (byte-identical apart from
// quote style) between components/ModelManagement.vue and views/GPTModelManagement.vue.
// Pure functions over their arguments; findExistingCategory/findCategoryByName stay
// per-file because their bodies diverge.
export default {
  methods: {
    normalizeCategoryDisplayName(value) {
      return typeof value === 'string' ? value.trim().replace(/\s+/g, ' ') : '';
    },
    normalizeCategoryName(value) {
      return this.normalizeCategoryDisplayName(value).toLowerCase();
    },
    categoryNameRequiredRule(value) {
      const rawValue = typeof value === 'object' ? value?.name : value;
      return !!this.normalizeCategoryDisplayName(rawValue) || 'Required';
    },
    normalizeCategoryOption(category) {
      if (!category) {
        return null;
      }

      const categoryName = this.normalizeCategoryDisplayName(
        typeof category === 'string' ? category : (category.name ?? category.categoryName)
      );

      if (!categoryName) {
        return null;
      }

      return {
        id: typeof category === 'object' ? (category.id ?? category.categoryID ?? null) : null,
        name: categoryName,
      };
    },
    dedupeCategories(categories) {
      const seen = new Set();

      return (Array.isArray(categories) ? categories : [])
        .map((category) => this.normalizeCategoryOption(category))
        .filter((category) => {
          if (!category) {
            return false;
          }

          const normalizedName = this.normalizeCategoryName(category.name);
          if (!normalizedName || seen.has(normalizedName)) {
            return false;
          }

          seen.add(normalizedName);
          return true;
        });
    },
  },
};
